export class SavedSearchesItemModel {
    public id: string;
    public name: string;
    public url: string;
    public filters: string;
}
